// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__7Es9X","calendarButtons":"ClockData_calendarButtons__cmKkW"};